import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import { SnackbarProvider } from 'notistack';
import { styled } from '@mui/material/styles';

// Styled components for the silk background effect
const SilkBackground = styled(Box)(({ theme }) => ({
  background: 'linear-gradient(45deg, #ffd6d6 30%, #ffe6e6 90%)',
  padding: theme.spacing(6),
  borderRadius: theme.spacing(2),
  position: 'relative',
  overflow: 'hidden',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: '150px',
    background: `
      radial-gradient(circle at 50% 0%, rgba(255,255,255,0.4) 0%, transparent 75%),
      linear-gradient(135deg, rgba(255,255,255,0.3) 0%, rgba(255,255,255,0) 50%, rgba(255,255,255,0.3) 100%)
    `,
    transform: 'scaleX(1.5)',
    transformOrigin: 'center top',
    animation: 'waveEffect 15s ease-in-out infinite alternate',
  },
  '&::after': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: '100%',
    background: `
      repeating-linear-gradient(
        45deg,
        rgba(255,255,255,0.1) 0px,
        rgba(255,255,255,0.1) 2px,
        transparent 2px,
        transparent 4px
      ),
      linear-gradient(to bottom, rgba(255,255,255,0.2) 0%, transparent 100%)
    `,
    opacity: 0.5,
  },
  '@keyframes waveEffect': {
    '0%': {
      transform: 'scaleX(1.5) translateY(0) translateX(-5%)',
    },
    '50%': {
      transform: 'scaleX(1.5) translateY(-2%) translateX(5%)',
    },
    '100%': {
      transform: 'scaleX(1.5) translateY(0) translateX(-5%)',
    },
  },
}));

const StyledContainer = styled(Container)(({ theme }) => ({
  position: 'relative',
  '&::before': {
    content: '""',
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    height: '200px',
    background: 'linear-gradient(180deg, #ffd6d6 0%, transparent 100%)',
    pointerEvents: 'none',
    zIndex: -1,
  }
}));

const StyledTitle = styled(Typography)(({ theme }) => ({
  fontFamily: '"Pinyon Script", "Great Vibes", cursive',
  marginBottom: theme.spacing(4),
  textAlign: 'center',
  fontSize: '3.5rem',
  fontWeight: 400,
  color: '#000000',
  letterSpacing: '0.02em',
  lineHeight: 1.3,
  textShadow: '2px 2px 3px rgba(0,0,0,0.05)',
  fontStyle: 'italic',
  '&::first-letter': {
    fontSize: '4rem',
    verticalAlign: 'baseline'
  }
}));

const StyledSection = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(6),
  position: 'relative',
}));

const About = ({ content }: any) => {
  return (
    <StyledContainer maxWidth="lg" sx={{ py: 8 }}>
      <StyledSection>
        <SilkBackground>
          <StyledTitle>About Us</StyledTitle>
          <Typography variant="body1" paragraph align="center" sx={{ fontSize: '1.2rem' }}>
            {content?.aboutContent}
          </Typography>
        </SilkBackground>
      </StyledSection>
      <StyledSection>
        <SilkBackground>
          <StyledTitle>Vision Statement</StyledTitle>
          <Typography variant="body1" paragraph align="center" sx={{ fontSize: '1.2rem' }}>
            {content?.visionStatement}
          </Typography>
        </SilkBackground>
      </StyledSection>

      <StyledSection>
        <SilkBackground>
          <StyledTitle>Mission Statement</StyledTitle>
          <Typography variant="body1" paragraph align="center" sx={{ fontSize: '1.2rem' }}>
            {content?.missionStatement}
          </Typography>
        </SilkBackground>
      </StyledSection>
      <SnackbarProvider />
    </StyledContainer>
  );
};

export default About; 